import React, { useState, useContext, useCallback } from "react"
import { UserContext } from "../../../context/userContext"
import _ from "lodash"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import BroadcastChat from "./BroadcastChat"
import BroadcastLeftConvList from "./BroadcastLeftConvList"
import BroadcastNew from "./BroadcastNew"
import {
  trApiGetBroadcastById,
  trApiGetBroadcastsListByStaffGroupId,
} from "../telerecoveryApi"

export default function BroadcastTab() {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [newBroadcast, setNewBroadcast] = useState(true)
  const [broadcastGroupList, setBroadcastGroupList] = useState([])
  const [loadingGroupList, setLoadingGroupList] = useState(true)
  const [loadingGroupData, setLoadingGroupData] = useState(false)

  const loadBroadcastGroupConvs = useCallback(() => {
    setLoadingGroupList(true)

    trApiGetBroadcastsListByStaffGroupId(
      userCtx.tokens.getTelerecoveryToken(),
      user.organization_id,
    ).then(
      (response) => {
        setBroadcastGroupList(response)
        setLoadingGroupList(false)
      },
      (err) => console.log(err),
    )
  })

  React.useEffect(() => {
    loadBroadcastGroupConvs()
  }, [])

  const openGroupConv = useCallback((broadcastGroupId) => {
    setNewBroadcast(false)
    setLoadingGroupData(true)

    trApiGetBroadcastById(
      userCtx.tokens.getTelerecoveryToken(),
      broadcastGroupId,
    ).then(
      (response) => {
        setSelectedGroup(response)
        setLoadingGroupData(false)
      },
      (err) => console.log(err),
    )
  }, [])

  const openNewBroadcastForm = useCallback(() => {
    setNewBroadcast(true)
    setSelectedGroup(null)
  })

  const onMessageSent = useCallback((broadcastGroupId) => {
    openGroupConv(broadcastGroupId)
    loadBroadcastGroupConvs()
  })

  return (
    <div
      className={styles.wrapper}
      style={{ minHeight: "600px", margin: "0px" }}
    >
      <BroadcastLeftConvList
        groupConvList={broadcastGroupList}
        openGroupConv={openGroupConv}
        openNewBroadcastForm={openNewBroadcastForm}
        loadingGroupList={loadingGroupList}
      />
      {newBroadcast === false && selectedGroup && (
        <BroadcastChat
          group={selectedGroup}
          loadingGroupData={loadingGroupData}
        />
      )}
      {newBroadcast === true && (
        <BroadcastNew onMessageSent={onMessageSent}></BroadcastNew>
      )}
    </div>
  )
}
